import PropTypes from 'prop-types';
import {
  Check,
  MoreHoriz,
  PriorityHigh,
  RadioButtonUnchecked
} from '@mui/icons-material';
import './PaymentStatusIcon.css';

/**
 * PaymentStatusIcon component.
 *
 * Displays a consistent payment status icon across the application.
 * Used in both new booking checkout and existing booking payment forms.
 *
 * @param {Object} props - Component props
 * @param {string} props.status - Payment status: 'completed', 'due-today' (or 'dueToday'), 'overdue', 'upcoming'
 * @returns {JSX.Element} - Payment status icon
 */
const PaymentStatusIcon = ({ status }) => {
  // Normalize status to handle both kebab-case and camelCase
  const normalizedStatus = status === 'dueToday' ? 'due-today' : status;

  const getIcon = () => {
    switch (normalizedStatus) {
      case 'completed':
        return <Check style={{ fontSize: 14, color: '#FFFFFF' }} />;
      case 'due-today':
        return <MoreHoriz style={{ fontSize: 14, color: '#FFFFFF' }} />;
      case 'overdue':
        return <PriorityHigh style={{ fontSize: 14, color: '#FFFFFF' }} />;
      case 'upcoming':
        return (
          <RadioButtonUnchecked style={{ fontSize: 14, color: '#9CA3AF' }} />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`payment-status-icon payment-status-icon--${normalizedStatus}`}
    >
      {getIcon()}
    </div>
  );
};

PaymentStatusIcon.propTypes = {
  status: PropTypes.string.isRequired
};

export default PaymentStatusIcon;
